import { getToken } from './accessToken.js';
import { getItem, SESSION_STORAGE } from '@analytics/storage-utils';

const requestSuccessCallbackV3 = function (config) {
    // Do something before request is sent
    let customConfig = Object.assign({}, config);
    const sessionId = getItem("peek__session_id", { storage: SESSION_STORAGE });
    if (sessionId) {
        customConfig = Object.assign(Object.assign({}, config), { headers: Object.assign(Object.assign({}, config.headers), { "X-Amzn-Trace-Id": `PeekSessionId=${sessionId}` }) });
    }
    const token = getToken();
    if (token) {
        customConfig = Object.assign(Object.assign({}, config), { headers: Object.assign({ Authorization: `Bearer ${token}` }, customConfig.headers) });
    }
    return customConfig;
};
const responseSuccessCallbackV3 = function (config) {
    return config.data;
};
const responseFailCallbackV3 = function (error) {
    var _a, _b, _c;
    // Do something with request error
    const { message = (_a = error === null || error === void 0 ? void 0 : error.message) !== null && _a !== void 0 ? _a : "We are facing an issue. Please try again later.", payload, response_code, } = ((_b = error === null || error === void 0 ? void 0 : error.response) === null || _b === void 0 ? void 0 : _b.data) || {};
    return Promise.reject(new Error(message, {
        cause: {
            //@ts-ignore
            code: response_code || ((_c = error === null || error === void 0 ? void 0 : error.response) === null || _c === void 0 ? void 0 : _c.status),
            data: payload,
        },
    }));
};

export { requestSuccessCallbackV3, responseFailCallbackV3, responseSuccessCallbackV3 };
